import {
  UserActivityAnalyticsPage,
  normalizeUserActivityPageTab,
  type UserActivityAdminApi,
  type UserActivityPageTab
} from '@jarvis/platform-ui';
import { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import {
  getUserActivityAnalytics,
  getUserActivityLive,
  getUserActivitySummary,
  listUserActivitySessions
} from '../../../api/userActivity';

const userActivityApi: UserActivityAdminApi = {
  getLive: getUserActivityLive,
  getAnalytics: getUserActivityAnalytics,
  getSummary: getUserActivitySummary,
  listSessions: listUserActivitySessions
};

export function UserActivitySummaryPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = normalizeUserActivityPageTab(tabParam) ?? undefined;

  const onTabChange = useCallback(
    (tab: UserActivityPageTab) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (tab === 'summary') next.delete('tab');
          else next.set('tab', tab);
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return (
    <UserActivityAnalyticsPage
      api={userActivityApi}
      stateStorageKey="assistantui:user-activity-history-grid"
      prefsStorageKey="assistant-user-activity-ui"
      initialTab={initialTab}
      onTabChange={onTabChange}
    />
  );
}

/** Legacy Access History route → Sessions tab. */
export function UserActivityHistoryRedirectPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/admin/user-activity?tab=sessions', { replace: true });
  }, [navigate]);
  return null;
}
